<template>
  <div class="sidebar">
    <div class="top-bar">
      <div class="top-left">
        <template v-if="isLoggedIn && isRealNameVerified">
          <img :src="require('@/assets/image/name.png')" alt="实名" class="name-icon" />
          <el-tag type="success" size="mini" class="verified-tag">已实名</el-tag>
        </template>
        <el-tag v-else-if="isLoggedIn" type="info" size="mini" class="verified-tag">未实名</el-tag>
      </div>
      <div class="settings" @click="$router.push('/member-center/settings')">
        <i class="el-icon-setting"></i>设置
      </div>
    </div>
    <div class="user-profile">
      <div class="avatar">
        <el-avatar :size="80" :src="avatarUrl" fit="cover">{{ avatarText }}</el-avatar>
      </div>
      <div class="user-info">
        <div class="user-name">{{ displayName }}</div>
        <div v-if="displayId" class="user-id">ID: {{ displayId }}</div>
        <div class="user-level-row">
          <span class="user-level-text">{{ displayLevelText }}</span>
          <el-button type="warning" size="mini" class="rights-btn" @click="$router.push('/member-center/distribution-rights')">
            {{ hasPurchased ? '我的权益' : '查看分销权益' }}
          </el-button>
        </div>
      </div>
    </div>
    
    <div class="sidebar-nav">
      <div class="nav-item" :class="{ active: $route.path === '/member-center/courses' }" @click="$router.push('/member-center/courses')">我的课程</div>
      <div class="nav-item" :class="{ active: $route.path === '/member-center/coupons' }" @click="$router.push('/member-center/coupons')">我的优惠券</div>
      <div class="nav-item" :class="{ active: $route.path === '/member-center/classes' }" @click="$router.push('/member-center/classes')">我的班级</div>
      <div class="nav-item" :class="{ active: $route.path === '/member-center/orders' }" @click="$router.push('/member-center/orders')">我的订单</div>
      <div class="nav-item" :class="{ active: $route.path === '/member-center/collections' }" @click="$router.push('/member-center/collections')">我的收藏</div>
      <div class="nav-item" :class="{ active: $route.path === '/member-center/projects' }" @click="$router.push('/member-center/projects')">我的项目</div>
      <div class="nav-item" :class="{ active: $route.path === '/member-center/certificates' }" @click="$router.push('/member-center/certificates')">我的证书</div>
      <div class="nav-item" :class="{ active: $route.path === '/member-center/simulation' }" @click="$router.push('/member-center/simulation')">模拟练习</div>
      <div class="nav-item" :class="{ active: $route.path === '/member-center/exams' }" @click="$router.push('/member-center/exams')">我的考试</div>
      <div class="nav-item" :class="{ active: $route.path === '/member-center/error-notes' }" @click="$router.push('/member-center/error-notes')">错题记录</div>
      <div class="nav-item" :class="{ active: $route.path === '/member-center/address' }" @click="$router.push('/member-center/address')">地址管理</div>
      <!-- <div class="nav-item" :class="{ active: $route.path === '/member-center/messages' }" @click="$router.push('/member-center/messages')">站内信</div> -->
      <div class="nav-item logout-btn" @click="$emit('handle-logout')">退出登录</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AppSidebar',
  props: {
    activeNav: {
      type: String,
      default: 'all'
    },
    currentView: {
      type: String,
      default: 'courses'
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'isRealNameVerified', 'userInfo', 'username']),
    displayName() {
      if (!this.isLoggedIn) return '未登录'
      const info = this.userInfo || {}
      return this.username || info.realName || info.nickname || info.username || info.phone || info.mobile || '用户'
    },
    displayId() {
      const info = this.userInfo || {}
      return info.id || info.userId || info.uid || ''
    },
    displayLevel() {
      const info = this.userInfo || {}
      const level = Number(info.distributorLevel)
      console.log(info)
      if (!level || Number.isNaN(level) || level <= 0) return ''
      const map = {
        1: '一级分销商',
        2: '二级分销商',
        3: '三级分销商'
      }
      return map[level] || `分销商${level}级`
    },
    displayLevelText() {
      if (!this.isLoggedIn) return ''
      const info = this.userInfo || {}
      return info.levelName || info.level || '普通用户'
    },
    hasPurchased() {
      const info = this.userInfo || {}
      const level = Number(info.distributorLevel)
      return level > 0
    },
    avatarUrl() {
      const info = this.userInfo || {}
      return (info && info.avatar) ? String(info.avatar) : ''
    },
    avatarText() {
      const name = this.displayName || ''
      return name ? String(name).trim().slice(0, 1) : 'U'
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
/* 侧边栏样式 */
.sidebar {
    width: 320px;
    flex: 0 0 320px;
    min-width: 320px;
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;

  .top-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }
    .top-left {
      display: flex;
      align-items: center;
      gap: 4px;
      min-width: 0;
    }
    .name-icon {
      width: 16px;
      height: 16px;
      display: block;
      flex: 0 0 auto;
    }
    .verified-tag {
      background: #ecf5ff;
      border-color: #ecf5ff;
      color: #409eff;
    }
    .settings {
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      color: #606266;
      font-size: 14px;
    }
    .settings:hover { color: #409eff; }

  .user-profile {
    text-align: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;

    .avatar {
      margin-bottom: 12px;
      display: flex;
      justify-content: center;

      .el-avatar {
        width: 80px;
        height: 80px;
        font-size: 32px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        display: flex;
        align-items: center;
        justify-content: center;
      
      }

      ::v-deep .el-avatar > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .user-name {
      font-size: 18px;
      font-weight: 600;
      color: #333;
      margin-bottom: 4px;
      text-align: center;
    }

    .user-id {
      font-size: 14px;
      color: #999;
      margin-bottom: 8px;
    }


    .user-level-row {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin-top: 8px;

      .user-level-text {
        font-size: 13px;
        color: #666;
      }
      .rights-btn {
        padding: 4px 10px;
        font-size: 12px;
        border-radius: 4px;
        background: linear-gradient(90deg, #fdfbfb 0%, #ebedee 100%);
        color: #333;
        border: 1px solid #dcdfe6;
        font-weight: 500;
        &:hover {
          color: #e6a23c;
          border-color: #f5dab1;
          background: #fdf6ec;
        }
      }
      .rights-btn.el-button--warning {
        background: #fdf6ec;
        border-color: #f5dab1;
        color: #e6a23c;
      }
    }
  }

  .sidebar-nav {
    margin-top: 20px;

    .nav-item {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 16px;
      margin-bottom: 8px;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      color: #606266;
      text-decoration: none;
      transition: all 0.3s ease;

      &:hover {
        background-color: #f5f7fa;
        color: #409eff;
      }

      &.active {
        background-color: #ecf5ff;
        color: #409eff;
        font-weight: 500;
      }

      &.logout-btn {
        margin-top: 20px;
        color: #f56c6c;

        &:hover {
          background-color: #fef0f0;
        }
      }
    }
  }
}
</style>
